<template>
  <svg
    class="tg-turkey"
    :class="`tg-turkey--${moves}`"
    :viewBox="VIEW_BOX[framing]"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="thanksgiving-turkey-svg"
  >
    <!-- Animated groups carry no transform attribute (a CSS transform would replace it); joints pivot in CSS on
         explicit viewBox points: tail 60,74 · hips 52,104 and 68,104 · shoulders 40,78 and 80,78 · neck 60,64. -->
    <g class="tg-turkey__tail">
      <g transform="rotate(-80 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#7f1d1d" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#b91c1c" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(80 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#b45309" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#f59e0b" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(-60 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#9a3412" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#ea580c" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(60 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#9a3412" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#ea580c" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(-40 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#b45309" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#f59e0b" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(40 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#7f1d1d" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#b91c1c" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(-20 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#a16207" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#fbbf24" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(20 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#9a3412" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#ea580c" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
      <g transform="rotate(0 60 74)">
        <ellipse cx="60" cy="34" rx="11" ry="34" fill="#b45309" />
        <ellipse cx="60" cy="30" rx="6.5" ry="26" fill="#f59e0b" />
        <circle cx="60" cy="10" r="4.2" fill="#fde68a" />
        <circle cx="60" cy="10" r="2" fill="#7c2d12" />
      </g>
    </g>

    <g class="tg-turkey__leg tg-turkey__leg--l">
      <path d="M52 104v18" stroke="#f59e0b" stroke-width="4" stroke-linecap="round" />
      <path d="M52 122l-7 4M52 122l1 6M52 122l7 4" stroke="#f59e0b" stroke-width="3" stroke-linecap="round" />
    </g>
    <g class="tg-turkey__leg tg-turkey__leg--r">
      <path d="M68 104v18" stroke="#f59e0b" stroke-width="4" stroke-linecap="round" />
      <path d="M68 122l-7 4M68 122l1 6M68 122l7 4" stroke="#f59e0b" stroke-width="3" stroke-linecap="round" />
    </g>

    <g class="tg-turkey__body">
      <ellipse cx="60" cy="86" rx="27" ry="25" fill="#7c4a24" />
      <ellipse cx="60" cy="92" rx="16" ry="16" fill="#a26a3c" />
      <path
        d="M36 92c2 4 5 7 9 8M38 100c3 3 6 5 10 5M84 92c-2 4-5 7-9 8M82 100c-3 3-6 5-10 5"
        stroke="#5c3418"
        stroke-width="2"
        stroke-linecap="round"
      />
      <!-- The OP badge sits on the breast and moves with the body. -->
      <circle cx="60" cy="92" r="12.5" fill="#5b1fd3" />
      <circle cx="60" cy="92" r="12.5" stroke="#fbbf24" stroke-width="1.6" />
      <g transform="translate(40.8 70.8) scale(2.5)" fill="#ffffff">
        <path
          d="M7.68626 8.68484L6.35563 7.67335L5.88281 8.25907L7.75212 9.70497L11.3857 5.19165L10.4753 5.125L7.68626 8.68484Z"
        />
        <path
          d="M10.3804 7.56712C9.95309 9.03497 9.04745 10.2229 7.63606 11.1615C6.71159 10.6544 5.96107 9.88098 5.48212 8.94166C5.04616 8.09326 4.78583 7.04883 4.70585 5.82876C5.71725 5.69101 6.71075 5.44415 7.66899 5.09248C8.17396 5.28801 8.69033 5.45272 9.21525 5.58568L9.70845 4.9584C9.01261 4.80151 8.33117 4.58643 7.67134 4.31543C6.55086 4.76786 5.30569 5.05327 3.95703 5.19206C4.00016 8.29085 5.02812 10.7051 7.67134 11.9997C9.8049 10.7051 11.0924 8.86795 11.3433 6.3643L10.3804 7.56712Z"
        />
      </g>
      <!-- Thanksgiving Day only: an award rosette beside the OP badge (the banner is drawn at the feet). -->
      <g v-if="pardoned" data-testid="thanksgiving-turkey-rosette">
        <path d="M71 79l-4 13 4-2 2 4 2-13zM77 79l4 13-4-2-2 4-2-13z" fill="#dc2626" />
        <circle cx="74" cy="74" r="7.5" fill="#fbbf24" />
        <circle cx="74" cy="74" r="7.5" stroke="#b45309" stroke-width="1.2" stroke-dasharray="2 1.4" />
        <circle cx="74" cy="74" r="4" fill="#f59e0b" />
        <path
          d="M72 74l1.5 1.5 3-3"
          stroke="#7c2d12"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <g class="tg-turkey__wing tg-turkey__wing--l">
        <path d="M40 78c-10 2-15 12-12 22 6-2 12-6 15-14z" fill="#5c3418" />
        <path d="M31 94c3-1 6-3 8-6M30 99c3-1 6-3 9-6" stroke="#7c4a24" stroke-width="1.6" stroke-linecap="round" />
      </g>
      <g class="tg-turkey__wing tg-turkey__wing--r">
        <path d="M80 78c10 2 15 12 12 22-6-2-12-6-15-14z" fill="#5c3418" />
        <path d="M89 94c-3-1-6-3-8-6M90 99c-3-1-6-3-9-6" stroke="#7c4a24" stroke-width="1.6" stroke-linecap="round" />
      </g>
    </g>

    <g class="tg-turkey__head">
      <path d="M54 66c0-6 2-10 6-12 4 2 6 6 6 12z" fill="#8b5a2b" />
      <circle cx="60" cy="46" r="12" fill="#8b5a2b" />
      <g class="tg-turkey__eyes">
        <circle cx="55.5" cy="44" r="3.4" fill="#ffffff" />
        <circle cx="64.5" cy="44" r="3.4" fill="#ffffff" />
        <circle class="tg-turkey__pupil" cx="56" cy="44.6" r="1.7" fill="#1d2433" />
        <circle class="tg-turkey__pupil" cx="65" cy="44.6" r="1.7" fill="#1d2433" />
      </g>
      <path d="M56.5 49h7L60 54z" fill="#f59e0b" />
      <path d="M61 51c3 1.5 4 5 2.4 8.4-2.2-.8-3.4-3.6-2.4-8.4z" fill="#dc2626" />
      <path d="M48 36.5 50.5 22h19L72 36.5z" fill="#1d2433" />
      <path d="M43 35.5h34v4H43z" fill="#1d2433" />
      <path d="M49.4 30.5h21.2v3.4H49.4z" fill="#5b1fd3" />
      <path d="M56.4 29.2h7.2v5.8h-7.2z" fill="#fbbf24" />
      <path d="M58.2 30.8h3.6v2.6h-3.6z" fill="#1d2433" />
    </g>
    <g v-if="pardoned" data-testid="thanksgiving-turkey-sash">
      <path d="M14 113h92l-6 6.5 6 6.5H14l6-6.5z" fill="#dc2626" />
      <path d="M14 113h92l-1 1.2H15z" fill="#fca5a5" opacity="0.6" />
      <text
        x="60"
        y="122.6"
        text-anchor="middle"
        font-size="9"
        font-weight="800"
        letter-spacing="1"
        fill="#ffffff"
        font-family="Geist, sans-serif"
      >
        PARDONED
      </text>
    </g>
  </svg>
</template>

<script lang="ts">
export enum TurkeyFraming {
  // The whole bird, fan tips to toes.
  FULL = 'full',
}

export enum TurkeyMoves {
  DANCE = 'dance',
  GOBBLE = 'gobble',
  IDLE = 'idle',
  SHOCK = 'shock',
  STRUT = 'strut',
}
</script>

<script setup lang="ts">
const VIEW_BOX: Record<TurkeyFraming, string> = {
  [TurkeyFraming.FULL]: '-28 -14 176 146',
};

withDefaults(defineProps<{ framing?: TurkeyFraming; moves: TurkeyMoves; pardoned?: boolean }>(), {
  framing: TurkeyFraming.FULL,
  pardoned: false,
});
</script>
